import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'
import { Sales } from '@fortem-monorepo/web-sdk'

import { toastApiError } from '@/lib/error-toast'

export const useSendEmailMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: Sales.SendSalesEmailBody) => api.sales.sendEmail(body),
    onSuccess: (_data, params) => {
      toast.success(`Email sent to ${params.recipient}`)
    },
    onError: (error, params) => {
      toastApiError(error, `Error sending email to ${params.recipient}`)
    },
  })
}
